// extracted by mini-css-extract-plugin
export var chip = "_m9-2";
export var chipBody = "_m9-8";
export var chipHeader = "_m9-9";
export var chipWithKind = "_m9-7";
export var icon = "_m9-3";
export var kind = "_m9-a";
export var remove = "_m9-5";
export var removeIcon = "_m9-6";
export var row = "_m9-0";
export var rowHistorical = "_m9-1";
export var text = "_m9-4";